import { useLocation, useParams } from 'react-router-dom';
import { useEffect, useState } from "react";
import { authRequest } from '../../../common/request/authRequest';
import { ClockCircleFilled, EnvironmentFilled, InfoCircleFilled, PhoneFilled, ShopFilled } from '@ant-design/icons';
import { Divider, message } from 'antd';
import { FormHorario } from '../../molecules/forms/FormHorario';

export const WidgetsContact = ({ id: webConfigId }) => {

    let { id: widgetId } = useParams();
    const key = webConfigId || widgetId;
    const path = useLocation();
    const storeCode = new URLSearchParams(path.search).get('storeCode');    
    const color = 'DodgerBlue';
    const [location, setLocation] = useState();

    let extraQueryParams = storeCode ? '&storeCode=' + storeCode : '';    

    useEffect(() => {
                
        authRequest(`${process.env.REACT_APP_API}/widgets/contact?key=${key}${extraQueryParams}`, {})
            .then((location) => {
                setLocation(location);
            }).catch((error) => {

            }
        )        
    }, []);    

    return (
        <div style={{padding:'25px'}}>
        
            {location && 
            <>
            <h2 style={{marginBottom:'5px'}}>Datos de Contacto</h2>        
            <div style={{marginBottom:'35px', borderRadius:'10px', height:'6px', width: '250px', margin:'10px', background:`linear-gradient(to right, transparent, ${color})`}}/>                
            
            <div style={{display:'flex', gap:'20px', height:'100%'}}>
                <div style={{width: '50%', height: '100%', background:'GhostWhite', position:'relative', backgroundColor: `white`, borderRadius: '15px', display: 'flex', flexDirection: 'column', padding: '20px', gap: '20px' }}>
                    <h3 style={{ textAlign: 'start' }}>
                        <div><ShopFilled style={{ color: `${color}`, marginRight: '15px' }} />{location?.title}</div>                            
                    </h3>                    
                    <div>
                        {/*<div className="logo" style={{position:'absolute', right:30, display:'none'}}>
                            <img src={logo} />
                        </div>*/}
                        <h3> <PhoneFilled style={{ color: `${color}`, marginRight: '15px' }} />
                            Teléfono
                        </h3>
                        <div style={{ marginLeft: '30px' }}>{location?.primaryPhone}</div>
                    </div>
                    {location?.addressLine && <div>
                        <h3 style={{ textAlign: 'start' }}>
                            <div><EnvironmentFilled style={{ color: `${color}`, marginRight: '15px' }} />Dirección</div>                            
                        </h3>
                        <div style={{ marginLeft: '30px' }}>{location?.addressLine}, {location?.postalCode}</div>                            
                        <div style={{ marginLeft: '30px' }}>{location?.locality},  {location?.administrativeArea}</div>
                    </div>}
                </div>
                    {/*<Divider style={{ backgroundColor: `${color}44` }}  />*/}
                <div className="web-contact" style={{width: '50%', background:'GhostWhite', position:'relative', backgroundColor: `white`, borderRadius: '15px', display: 'flex', flexDirection: 'column', padding: '20px', gap: '20px' }}>
                        
                    <h3><ClockCircleFilled style={{ color: `${color}`, marginRight: '15px' }} />Horario</h3>
                    {location?.regularHours?.length > 0 && 
                        <div style={{ marginLeft: '30px', width:'240px' }}>
                            <FormHorario title="Lunes" regularHour={location?.regularHours[0]} />
                            <FormHorario title="Martes" regularHour={location?.regularHours[1]} />
                            <FormHorario title="Miércoles" regularHour={location?.regularHours[2]} />
                            <FormHorario title="Jueves" regularHour={location?.regularHours[3]} />
                            <FormHorario title="Viernes" regularHour={location?.regularHours[4]} />
                            <FormHorario title="Sábado" regularHour={location?.regularHours[5]} />
                            <FormHorario title="Domingo" regularHour={location?.regularHours[6]} />
                        </div>
                    }
                </div>
                {/*map && <GoogleMap location={location} />*/}
            </div>
            </>}
        </div>
    )
}